// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"637":"b2579c67","1660":"b2579c67","5378":"edb30248"}[chunkId] + ".chunk.css";
};